/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../reducers';
import { DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { logout } from '../../../actions/auth';
import { Avatar } from '@g17eco/atoms/avatar';
import { isStaff } from '../../../selectors/user';
import { generateUrl } from '../../../routes/util';
import { ROUTES } from '../../../constants/routes';
import './styles.scss';
import { ExtraFeature, FeatureStability } from '@g17eco/molecules/feature-stability';
import { LoadingPlaceholder } from '@g17eco/molecules/loader-container';

const UserDetail = () => {
  const userState = useAppSelector((state) => state.currentUser);
  const isUserStaff = useAppSelector(isStaff);

  const history = useHistory();
  const dispatch = useAppDispatch();
  const user = userState.data;

  const handleProfileClick = (e: React.MouseEvent<any, MouseEvent>) => {
    e.preventDefault();
    history.push('/user-profile');
  }

  const handleLogout = (e: React.MouseEvent<any, MouseEvent>) => {
    e.preventDefault();
    dispatch(logout('/'))
  }

  if (userState.errored) {
    return null;
  }

  if (!userState.loaded) {
    return (
      <div className='user-detail d-flex mr-2'>
        <LoadingPlaceholder />
      </div>
    );
  }
  return (
    <div className='user-detail d-flex'>
      <UncontrolledDropdown>
        <DropdownToggle
          color='transparent'
          className='dropdown-toggle-nocaret d-flex align-items-center'
          data-testid='user-profile-nav-btn'
        >
          <div className='avatar-container'>
            <Avatar width='30px'>{user.profile ? <img alt='avatar' src={user.profile} /> : undefined}</Avatar>
          </div>
          <div className='ml-2 mr-2 mobile-hidden'>
            <div className='user-name dont_translate'>{user.name}</div>
          </div>
        </DropdownToggle>
        <DropdownMenu end>
          {isUserStaff ? (
            <>
              <DropdownItem divider />
              <DropdownItem color='link' onClick={() => history.push(generateUrl(ROUTES.STATS))}>
                <FeatureStability feature={ExtraFeature.StaffReports} className='ml-0 mr-2' />
                Staff Reports
              </DropdownItem>
              <DropdownItem color='link' onClick={() => history.push(generateUrl(ROUTES.THEME_SHOWCASE))}>
                <FeatureStability stability='internal' className='ml-0 mr-2' />
                Theme Showcase
              </DropdownItem>
            </>
          ) : null}
          <DropdownItem divider />
          <DropdownItem color='link' onClick={handleProfileClick}>
            <i className='fa fa-user-edit mr-2' />
            View Profile
          </DropdownItem>
          <DropdownItem color='link' onClick={handleLogout}>
            <i className='fa fa-sign-out-alt mr-2' />
            Logout
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  );
}

export default UserDetail;
